import React, { memo } from "react";
import OrderCartItemComponent from "@components/molecules/OrderCartItemCard/index";
import Routes from "@navigations/Routes";
import { OrderCartSummaryListProps } from "@scenes/configurator/OrderCart/types";
import { ProductCategory, SectionName } from "@utils/constants";
import { setBuilderProduct, setProductType } from "@redux/slices/appStateSlice";
import { BreadCrumbLabel } from "@components/molecules/Breadcrumbs/utils";
import { useDispatch } from "react-redux";
import { useNavigationHistory } from "../../../hooks/useNavigationHistory";
import { setSectionName } from "@redux/slices/searchFilters";
import { SelectedItemsProvider } from "../../../contexts/SelectedItemsContext";
import { remapConfigKeys } from "../utils/utils";
import { push } from "@navigations/utils/RootNavigation";
import { showRequestItemFromSupplier } from "@scenes/requests/utils/utils";

const BuilderRequestSummaryList = ({
  itemList,
  priceMode,
  productType,
  isBuilderItem,
  params: requestParams,
  display_configuration,
  display_configuration_v2,
}: OrderCartSummaryListProps) => {
  const dispatch = useDispatch();
  const { addRouteToHistory, clearRouteHistory } = useNavigationHistory();
  const jewelryItem = itemList.find(
    (item) =>
      item?.stock_item_type === ProductCategory.JEWELRY ||
      item?.stock_item_type === ProductCategory.LABGROWN_JEWELRY
  );
  const stoneItem = itemList.filter(
    (item) =>
      item?.stock_item_type === ProductCategory.DIAMOND ||
      item?.stock_item_type === ProductCategory.LAB_GROWN_DIAMOND ||
      item?.stock_item_type === ProductCategory.GEMSTONE
  );

  let stoneItem1 = stoneItem[0];
  let stoneItem2;
  if (stoneItem.length === 2) {
    stoneItem2 = stoneItem[1];
  }

  const RenderedItem = ({ i }: any) => {
    return (
      <>
        <OrderCartItemComponent
          key={i}
          mItem={jewelryItem?.[jewelryItem.stock_item_type]}
          priceMode={priceMode}
          productType={productType}
          showRemoveIcon={false}
          isBuilderItem={isBuilderItem}
          configDetails={jewelryItem?.configuration_details}
          showRequestItemFromSupplier={showRequestItemFromSupplier(jewelryItem)}
          deepLink={jewelryItem?.deep_link ?? ""}
          showRequestItemFromSupplierStone1={showRequestItemFromSupplier(
            stoneItem1
          )}
          stoneItem1={stoneItem1?.[stoneItem1.stock_item_type]}
          deepLinkStone1={stoneItem1?.deep_link ?? ""}
          {...(stoneItem2 && {
            stoneItem2: stoneItem2?.[stoneItem2.stock_item_type],
          })}
          onPress={() => {
            const config = remapConfigKeys(
              display_configuration_v2,
              jewelryItem?.configuration_details?.config
            );
            const additionalAttributes = {
              config: config,
              personalization:
                jewelryItem?.additional_attributes?.personalization,
            };
            const params = {
              breadCrumbLabel: BreadCrumbLabel.REVIEW,
              enterSecondFlow: true,
              priceMode: priceMode,
              productPrefix: ProductCategory.JEWELRY,
              productType: ProductCategory.JEWELRY,
              itemDetail: {
                ...jewelryItem?.[jewelryItem.stock_item_type],
                display_configuration: display_configuration,
                display_configuration_v2: display_configuration_v2,
                configuration_details: remapConfigKeys(
                  display_configuration_v2,
                  jewelryItem?.configuration_details?.config
                ),
                custom_design_configuration: true,
              },
              stoneItemDetail: stoneItem1?.[stoneItem1.stock_item_type],
              matchingPairItemDetail: stoneItem2?.[stoneItem2.stock_item_type],
              additionalAttributes: JSON.stringify(additionalAttributes),
              fromRequest: true,
            };
            const mRoute = { name: Routes.ReviewPage, params };
            const requestRoute = {
              name: Routes.RequestDetailScreen,
              params: {
                ...requestParams,
                breadCrumbLabel: BreadCrumbLabel.REQUEST_DETAILS,
              },
            };
            dispatch(setProductType(ProductCategory.JEWELRY));
            dispatch(setSectionName(SectionName.JEWELRY));
            dispatch(setBuilderProduct(ProductCategory.JEWELRY));
            clearRouteHistory();
            addRouteToHistory(requestRoute);
            addRouteToHistory(mRoute);
            push(Routes.GlobalNavigator, {
              screen: Routes.ReviewPage,
              params,
            });
          }}
        />
      </>
    );
  };
  return (
    <SelectedItemsProvider>
      <RenderedItem />
    </SelectedItemsProvider>
  );
};

export default memo(BuilderRequestSummaryList, (prevProps, nextProps) => {
  return (
    JSON.stringify(prevProps.itemList) === JSON.stringify(nextProps.itemList)
  );
});
